module.exports = "<div class=\"modal fade\" id=\"banner-modal-{{trailId}}\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <app-banner [item]=\"banner.data[0]\"></app-banner>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/listagem-cursos/banner/banner.component.html
// module id = ./src/app/shared/listagem-cursos/banner/banner.component.html
// module chunks = main